import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';

export default function GoogleAnalyticsPageview() {
  const { pathname } = useLocation();
  const [initialPageLoaded, setInitialPageLoaded] = useState(false);

  useEffect(() => {
    let observer;
    if (initialPageLoaded) {
      observer = new MutationObserver(() => {
        if (!(window as any).dataLayer) return;

        (window as any).dataLayer.push({ event: 'page_view' });
      })

      observer.observe(document.querySelector('title'), { childList: true });
      // (window as any).dataLayer.push({ event: 'page_view', page_location: pathname, page_title: 'Test' });
    }

    setInitialPageLoaded(true);
    return () => observer?.disconnect();
  }, [pathname]);

  return null;
};
